import useGetWebTippsConfigurations from './useGetWebTippsConfigurations'

export default useGetWebTippsConfigurations
